import { Stack, Box, Typography, } from '@mui/material';
import * as React from 'react';
import * as JSTool from '../store/JSTool';
import { useSelector, useDispatch } from 'react-redux';
import { settingActions, settingObj } from '../store/SettingSlice';

export default function RightFloatView(props) {

    const dispatch = useDispatch();
    const settingData = useSelector(state => state.settingData);

    return (
        <Stack
            id={'home_page_right_view'}
            sx={{
                position: 'fixed',
                zIndex: 999,
                right: settingData.isMobile ? 0 : 20,
                bottom: 0,
                alignItems: 'center'
            }}>

            <Stack sx={{
                backgroundImage: `url(${JSTool.getImgPath('share_bg.png')})`,
                backgroundSize: '100% 100%',
                height: '250rem',
                width: '200rem',
                alignItems: 'center',
                color: 'red',
                zIndex: 1,
            }}>

                <Typography sx={{
                    color: 'white',
                    fontFamily: window.font0,
                    fontSize: '13rem',
                    mt: '44rem',
                }}>
                    Follow
                </Typography>

                <Typography sx={{
                    color: 'white',
                    fontFamily: window.font0,
                    fontSize: '13rem',
                    mt: -0.5,
                }}>
                    Us
                </Typography>

                <Stack sx={{
                    flexDirection: 'row',
                }}>

                    <Box
                        onClick={() => { JSTool.twitterTap() }}
                        component={'img'}
                        src={JSTool.getImgPath('twitter.png')}
                        sx={{
                            height: '33rem',
                            mr: 1,
                            cursor: 'pointer',
                            transitionDuration: '0.3s',
                            '&:hover': {
                                transform: 'scale(1.15)',
                            }
                        }} />

                    <Box
                        onClick={() => { JSTool.discordTap() }}
                        component={'img'}
                        src={JSTool.getImgPath('discord.png')}
                        sx={{
                            height: '33rem',
                            cursor: 'pointer',
                            transitionDuration: '0.3s',
                            '&:hover': {
                                transform: 'scale(1.15)',
                            }
                        }} />


                </Stack>
            </Stack>


            <Stack sx={{
                backgroundImage: `url(${JSTool.getImgPath('top_bg.png')})`,
                backgroundSize: '100% 100%',
                width: '120rem',
                height: '120rem',
                justifyContent: 'center',
                alignItems: 'center',
                mt: -8,
            }}>
                <Box
                    component={'img'}
                    src={JSTool.getImgPath('top.png')}
                    sx={{
                        height: '20rem',
                        mt: 1.5,
                    }} />
                <Typography sx={{
                    color: 'white',
                    fontFamily: window.font0,
                    fontSize: '13rem'
                }}>
                    Top
                </Typography>
            </Stack>

            <Box
                onClick={()=>{
                    if(props.topTap){
                        props.topTap();
                    }
                }}
                sx={{
                    width: '90rem',
                    height: '90rem',
                    position: 'absolute',
                    bottom: 0,
                    cursor: 'pointer',
                    zIndex: 2,
                }} />

        </Stack>
    )

}